import stickyTableHeader from "./stickyTableHeader";

export default function(stickyTableId,sortingFunc,isLocal = false)
{
    let isDisplayFixedHeader = false;
    // let refreshStockButton;
    let callback;
    let headerHeight = null;
    const sort = sortingFunc;
    // table elelment with unique id
    const tableElement = document?.getElementById(stickyTableId);
    // headerHeght contains height where we need to display static header
    
    if(isLocal)
    {
        headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
    }
    else
    {
        headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 65 + 1;
    }
    
    // Admin Toolbar header height adjustment
    const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

    if(adminToolBarHeight > 0)
    {
        headerHeight = headerHeight + adminToolBarHeight;
    }

    // is used to track only one header will display at a moment

    document.addEventListener("scroll", (ScrollEvent) => {
        // current table position from top
        const tablePosition = tableElement ? tableElement.getBoundingClientRect().y : false;
        const paginationPosition = document?.querySelectorAll("div.pagination-row") && document?.querySelectorAll("div.pagination-row").length > 0  ? document?.querySelectorAll("div.pagination-row")[0].getBoundingClientRect().y : 0; 

        if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
            //function used to display header clone after actual header height is less than headerHeight from top
            // function(id, headerHeight,  tableContainerId, noOfColummFixed, sort)
            // if (!document.getElementById("table_copy")) {
            callback = stickyTableHeader(stickyTableId, headerHeight, "sticky-table-wrapper", 3, sort)
            //fixed header display now on ui
            isDisplayFixedHeader = true
            // }
        } else {
            if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                // switch variable to false for track that clone header hide
                isDisplayFixedHeader = false;

                // function used to remove the clone header
                if(Object.prototype.toString.call(callback) == '[object Function]')
                {
                    callback();
                }
            }
        }

    })
    return () => {
        if (callback) {
            // switch variable to false for track that clone header hide
            isDisplayFixedHeader = false;
            // function used to remove the clone header
            callback();
        }
    }


}